__turbopack_context__.v({
  "arrivalHeader": "museum-module__AEEYpq__arrivalHeader",
  "arrivalMarks": "museum-module__AEEYpq__arrivalMarks",
  "artefact": "museum-module__AEEYpq__artefact",
  "artefactFloat": "museum-module__AEEYpq__artefactFloat",
  "artefactFull": "museum-module__AEEYpq__artefactFull",
  "artefactImage": "museum-module__AEEYpq__artefactImage",
  "artefactPhoto": "museum-module__AEEYpq__artefactPhoto",
  "artefactPlaceholder": "museum-module__AEEYpq__artefactPlaceholder",
  "artefactWide": "museum-module__AEEYpq__artefactWide",
  "backdropLedger": "museum-module__AEEYpq__backdropLedger",
  "bodyText": "museum-module__AEEYpq__bodyText",
  "bone": "museum-module__AEEYpq__bone",
  "calmButton": "museum-module__AEEYpq__calmButton",
  "celestial": "museum-module__AEEYpq__celestial",
  "chapter": "museum-module__AEEYpq__chapter",
  "chapterBlocks": "museum-module__AEEYpq__chapterBlocks",
  "chapterContent": "museum-module__AEEYpq__chapterContent",
  "chapterDate": "museum-module__AEEYpq__chapterDate",
  "chapterFrame": "museum-module__AEEYpq__chapterFrame",
  "chapterHeader": "museum-module__AEEYpq__chapterHeader",
  "chapterSources": "museum-module__AEEYpq__chapterSources",
  "chapterVeil": "museum-module__AEEYpq__chapterVeil",
  "contour": "museum-module__AEEYpq__contour",
  "courseWrap": "museum-module__AEEYpq__courseWrap",
  "creditMarks": "museum-module__AEEYpq__creditMarks",
  "disciplineBranch": "museum-module__AEEYpq__disciplineBranch",
  "disciplineBranches": "museum-module__AEEYpq__disciplineBranches",
  "disciplinePeriod": "museum-module__AEEYpq__disciplinePeriod",
  "disciplineRoot": "museum-module__AEEYpq__disciplineRoot",
  "disciplineRootLabel": "museum-module__AEEYpq__disciplineRootLabel",
  "disciplineRoots": "museum-module__AEEYpq__disciplineRoots",
  "disciplineSource": "museum-module__AEEYpq__disciplineSource",
  "displayText": "museum-module__AEEYpq__displayText",
  "editorialInstrument": "museum-module__AEEYpq__editorialInstrument",
  "equipmentEntry": "museum-module__AEEYpq__equipmentEntry",
  "equipmentList": "museum-module__AEEYpq__equipmentList",
  "equipmentPeriod": "museum-module__AEEYpq__equipmentPeriod",
  "exhibition": "museum-module__AEEYpq__exhibition",
  "exhibitionSubtitle": "museum-module__AEEYpq__exhibitionSubtitle",
  "facingConclusion": "museum-module__AEEYpq__facingConclusion",
  "facingLights": "museum-module__AEEYpq__facingLights",
  "farMountain": "museum-module__AEEYpq__farMountain",
  "harmPanel": "museum-module__AEEYpq__harmPanel",
  "ink": "museum-module__AEEYpq__ink",
  "instrumentEvolution": "museum-module__AEEYpq__instrumentEvolution",
  "instrumentField": "museum-module__AEEYpq__instrumentField",
  "instrumentForce": "museum-module__AEEYpq__instrumentForce",
  "instrumentGrid": "museum-module__AEEYpq__instrumentGrid",
  "instrumentHeader": "museum-module__AEEYpq__instrumentHeader",
  "instrumentKicker": "museum-module__AEEYpq__instrumentKicker",
  "instrumentMaterial": "museum-module__AEEYpq__instrumentMaterial",
  "instrumentMeasure": "museum-module__AEEYpq__instrumentMeasure",
  "instrumentPlate": "museum-module__AEEYpq__instrumentPlate",
  "instrumentRoute": "museum-module__AEEYpq__instrumentRoute",
  "instrumentTitle": "museum-module__AEEYpq__instrumentTitle",
  "layoutCentre": "museum-module__AEEYpq__layoutCentre",
  "layoutLeft": "museum-module__AEEYpq__layoutLeft",
  "layoutRight": "museum-module__AEEYpq__layoutRight",
  "ledgerBaseline": "museum-module__AEEYpq__ledgerBaseline",
  "ledgerDetails": "museum-module__AEEYpq__ledgerDetails",
  "legendLabel": "museum-module__AEEYpq__legendLabel",
  "legendMarks": "museum-module__AEEYpq__legendMarks",
  "legendPanel": "museum-module__AEEYpq__legendPanel",
  "live": "museum-module__AEEYpq__live",
  "museumKicker": "museum-module__AEEYpq__museumKicker",
  "museumRoot": "museum-module__AEEYpq__museumRoot",
  "nameMarks": "museum-module__AEEYpq__nameMarks",
  "nearMountain": "museum-module__AEEYpq__nearMountain",
  "observation": "museum-module__AEEYpq__observation",
  "originMarks": "museum-module__AEEYpq__originMarks",
  "placeAccess": "museum-module__AEEYpq__placeAccess",
  "placeContours": "museum-module__AEEYpq__placeContours",
  "placeCoordinates": "museum-module__AEEYpq__placeCoordinates",
  "placeField": "museum-module__AEEYpq__placeField",
  "placeGrid": "museum-module__AEEYpq__placeGrid",
  "placeHistoryWorld": "museum-module__AEEYpq__placeHistoryWorld",
  "placeMass": "museum-module__AEEYpq__placeMass",
  "placePlate": "museum-module__AEEYpq__placePlate",
  "placeRoute": "museum-module__AEEYpq__placeRoute",
  "placeWater": "museum-module__AEEYpq__placeWater",
  "railMarks": "museum-module__AEEYpq__railMarks",
  "reckoningMarks": "museum-module__AEEYpq__reckoningMarks",
  "river": "museum-module__AEEYpq__river",
  "ropeBase": "museum-module__AEEYpq__ropeBase",
  "ropeTravelled": "museum-module__AEEYpq__ropeTravelled",
  "ropeWrap": "museum-module__AEEYpq__ropeWrap",
  "sceneGrain": "museum-module__AEEYpq__sceneGrain",
  "sceneVignette": "museum-module__AEEYpq__sceneVignette",
  "scrollInvitation": "museum-module__AEEYpq__scrollInvitation",
  "settlementMarks": "museum-module__AEEYpq__settlementMarks",
  "skiBirchMarks": "museum-module__AEEYpq__skiBirchMarks",
  "skiBroadcastMarks": "museum-module__AEEYpq__skiBroadcastMarks",
  "skiCreditMarks": "museum-module__AEEYpq__skiCreditMarks",
  "skiDisciplineMarks": "museum-module__AEEYpq__skiDisciplineMarks",
  "skiEdgeShadow": "museum-module__AEEYpq__skiEdgeShadow",
  "skiFreeskiMarks": "museum-module__AEEYpq__skiFreeskiMarks",
  "skiFutureMarks": "museum-module__AEEYpq__skiFutureMarks",
  "skiGate": "museum-module__AEEYpq__skiGate",
  "skiGateMarks": "museum-module__AEEYpq__skiGateMarks",
  "skiGrooves": "museum-module__AEEYpq__skiGrooves",
  "skiHorizon": "museum-module__AEEYpq__skiHorizon",
  "skiLiftMarks": "museum-module__AEEYpq__skiLiftMarks",
  "skiMythMarks": "museum-module__AEEYpq__skiMythMarks",
  "skiPeopleMarks": "museum-module__AEEYpq__skiPeopleMarks",
  "skiSnowField": "museum-module__AEEYpq__skiSnowField",
  "skiSnowRelief": "museum-module__AEEYpq__skiSnowRelief",
  "skiSpeedCorridor": "museum-module__AEEYpq__skiSpeedCorridor",
  "skiTerrainMarks": "museum-module__AEEYpq__skiTerrainMarks",
  "skiTrackMarks": "museum-module__AEEYpq__skiTrackMarks",
  "skiTrackWorld": "museum-module__AEEYpq__skiTrackWorld",
  "skiWorkshopMarks": "museum-module__AEEYpq__skiWorkshopMarks",
  "skiWorldMarks": "museum-module__AEEYpq__skiWorldMarks",
  "skyBlock": "museum-module__AEEYpq__skyBlock",
  "skyPlate": "museum-module__AEEYpq__skyPlate",
  "snowLine": "museum-module__AEEYpq__snowLine",
  "sportHistoryWorld": "museum-module__AEEYpq__sportHistoryWorld",
  "stars": "museum-module__AEEYpq__stars",
  "statLine": "museum-module__AEEYpq__statLine",
  "storyDrawer": "museum-module__AEEYpq__storyDrawer",
  "summitMarks": "museum-module__AEEYpq__summitMarks",
  "timeline": "museum-module__AEEYpq__timeline",
  "timelineDate": "museum-module__AEEYpq__timelineDate",
  "timelineDot": "museum-module__AEEYpq__timelineDot",
  "timelineHeading": "museum-module__AEEYpq__timelineHeading",
  "timelineItem": "museum-module__AEEYpq__timelineItem",
  "timelineLink": "museum-module__AEEYpq__timelineLink",
  "timelineList": "museum-module__AEEYpq__timelineList",
  "timelineTitle": "museum-module__AEEYpq__timelineTitle",
  "tonightMarks": "museum-module__AEEYpq__tonightMarks",
  "trackWrap": "museum-module__AEEYpq__trackWrap",
  "valleyFloor": "museum-module__AEEYpq__valleyFloor",
  "verticalMarks": "museum-module__AEEYpq__verticalMarks",
  "window": "museum-module__AEEYpq__window",
  "winterMarks": "museum-module__AEEYpq__winterMarks",
  "world": "museum-module__AEEYpq__world",
  "worldHasVisual": "museum-module__AEEYpq__worldHasVisual",
  "worldPhoto": "museum-module__AEEYpq__worldPhoto",
  "worldPhotoBackdrop": "museum-module__AEEYpq__worldPhotoBackdrop",
  "worldPhotoContain": "museum-module__AEEYpq__worldPhotoContain",
  "worldPhotoContainMobile": "museum-module__AEEYpq__worldPhotoContainMobile",
  "worldPhotoForeground": "museum-module__AEEYpq__worldPhotoForeground",
  "worldPhotoImage": "museum-module__AEEYpq__worldPhotoImage",
  "worldToneArchive": "museum-module__AEEYpq__worldToneArchive",
  "worldToneNatural": "museum-module__AEEYpq__worldToneNatural",
  "worldToneNight": "museum-module__AEEYpq__worldToneNight",
});
